<template>
  <form>
      <div class="row q-col-gutter-md">
          <div class="col col-xs-12 col-md-6 col-lg-6">
              <q-input
                  v-model="OperatorObj.name"
                  :label="$t('operators.table_titles.name')"
                  lazy-rules
                  :error="OperatorObj.errors.has('name')"
                  :error-message="OperatorObj.errors.get('name')"
                  :rules="[ val => val && val.length > 0 || 'The Operator name is required!']"
                  color="input-color"
              />
          </div> <!-- NAME -->
          <div class="col col-xs-12 col-md-6 col-lg-6">
              <q-select
                  v-model="OperatorObj.country_id"
                  :label="$t('operators.table_titles.country')"
                  emit-value
                  map-options
                  option-value="id"
                  option-label="name"
                  :options="countries"
                  :loading="loading"
                  :error="OperatorObj.errors.has('country_id')"
                  :error-message="OperatorObj.errors.get('country_id')"
                  :rules="[ val => val && val > 0 || $t('operators.table_titles.country') + ' is required!']"
                  color="input-color"
              >
                  <template v-slot:option="scope">
                      <q-item
                          v-bind="scope.itemProps"
                          v-on="scope.itemEvents"
                          style="border-bottom:1px solid #999"
                      >
                          <q-item-section avatar>
                              <q-icon :name="scope.opt.acronym.toLowerCase()" size="xs" />
                          </q-item-section>
                          <q-item-section>
                              <q-item-label>{{scope.opt.name}}</q-item-label>
                          </q-item-section>
                      </q-item>
                  </template>
              </q-select>
          </div> <!-- COUNTRY -->
          <div class="col col-xs-12 col-sm-6 col-md-6">
              <p class="text-caption q-pb-xs" style="margin:0">Operator Type</p>
              <q-toggle
                  v-model="OperatorObj.is_individual"
                  checked-icon="fa fa-male"
                  color="input-color"
                  keep-color
                  unchecked-icon="fa fa-building"
                  :label="OperatorObj.is_individual ? 'Individual' : 'Company'"
              />
          </div> <!-- IS INDIVIDUAL -->
      </div>
    </form>
</template>

<script>

import {mapActions, mapGetters} from 'vuex'
export default {
  name: 'Form',
  model: {
    prop: 'OperatorObj'
  },
  props: {
    OperatorObj: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(['countries'])
  },
  data() {
    return {
        loading: false
    }
  },
  methods: {
    ...mapActions(['set_countries']),
    submit() {
      this.$emit('submit')
    },
  },
  created() {
    if (! this.countries.length) {
      this.loading = true
      this.set_countries().then(() => {this.loading = false}).catch(() => {this.loading = false})
    }
  },
  updated() {
    this.$emit('change', this.OperatorObj)
  },
  components: {},
}
</script>

<style scoped>

</style>
